import React  from "react";

export const FormulaireInstruction = (props) => {
    return (
        <p style={{textAlign: "center"}}>
            {props.instruction}
        </p>
    );
}
